
import { setBehaviourEvent } from './ga_interface';
import GA_EVENTS from './ga_constants';

const { servicesForm: { category, actions } } = GA_EVENTS;

const openServiceFormEvent = () => {
    const { open: action } = actions;
    setBehaviourEvent({ category, action, label: 'Open Service Form' });
};

const closeServiceFormEvent = (label) => {
    const { close: action } = actions;
    setBehaviourEvent({ category, action, label });
};

const servicesEvent = (state, label) => {
    const { select, deselect } = actions;
    const action = state ? select : deselect;
    setBehaviourEvent({ category, action, label });
};


const nextEvent = (label, value) => {
    const { next: action } = actions;
    setBehaviourEvent({ category, action, label, value });
};

const previousEvent = (label) => {
    const { previous: action } = actions;
    setBehaviourEvent({ category, action, label });
};

const submitEvent = (label, value) => {
    const { submit: action } = actions;
    setBehaviourEvent({ category, action, label, value });
};



export {
    openServiceFormEvent,
    closeServiceFormEvent,
    servicesEvent,
    nextEvent,
    previousEvent,
    submitEvent,
};